import ConsentContainer from './ConsentContainer';

export { ConsentContainer };
